import Axios from 'axios';
export const baseApi = Axios.create({
	baseURL: process.env.REACT_APP_API_URL,
	withCredentials: true,
});
